export default {"src":"/_next/static/media/app_store.b4ea6ce9.svg","height":62,"width":192};